import React, { useEffect, useState, useRef } from "react";
import axios from "../../Utilities/axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/logoSecond.png";
import "./Navbar.css";
import SpinnerPage from "./SpinnerPage";
import { FaChevronDown, FaUser, FaSignOutAlt, FaHeart } from "react-icons/fa";

const hotelsDropdown = [
  { label: "Lagos Hotels", path: "/availablehotels", stateName: "Lagos" },
  { label: "Abuja Hotels", path: "/availablehotels", stateName: "Abuja" },
  { label: "Enugu Hotels", path: "/availablehotels", stateName: "Enugu" },
  { label: "Anambra Hotels", path: "/availablehotels", stateName: "Anambra" },
];

const Navbar = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [userName, setUserName] = useState("");
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const dropdownRef = useRef(null);

  let availableHotel;

  const navigation = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const checkAuth = () => {
      const status = localStorage.getItem("loggInStatus");
      const userData = JSON.parse(localStorage.getItem("userData"));
      setIsLoggedIn(status === "true");
      if (userData) {
        setUserName(userData.firstName || "");
      }
    };
    checkAuth();
    window.addEventListener("storage", checkAuth);
    return () => window.removeEventListener("storage", checkAuth);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("loggInStatus");
    setIsLoggedIn(false);
    setUserName("");
    setMobileOpen(false);
    setShowLogoutModal(false);
    navigation("/");
  };

  const getHotels = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const mainAvailableHotel = await axios.get(
      `/registrations/hotels?sourceType=showInCompanySite&hotelGroupName=Residency`,
    );
    availableHotel = mainAvailableHotel.data;
    setIsLoading(false);
    navigation("/availablehotels", { state: { availableHotel } });
  };

  const handleDropdownClick = async (e, stateName) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await axios.get(
        `/registrations/hotels?sourceType=showInCompanySite&hotelGroupName=Residency`,
      );
      const filtered = res.data.filter(
        (hotel) =>
          hotel.location?.toLowerCase().includes(stateName.toLowerCase()) ||
          hotel.hotelName?.toLowerCase().includes(stateName.toLowerCase()),
      );
      navigation("/availablehotels", {
        state: { availableHotel: filtered, stateName },
      });
    } catch {
      navigation("/availablehotels", {
        state: { availableHotel: [], stateName },
      });
    }
    setIsLoading(false);
    setActiveDropdown(null);
  };

  const isActive = (path) => pathname === path;

  return (
    <>
      {isLoading && <SpinnerPage />}

      <nav className={`navbar site-nav ${isScrolled ? "is-scrolled" : ""} ${(pathname === "/Special-Promo" || pathname === "/EventHall" || pathname === "/About-Residency-Hotels") ? "site-nav--light" : ""}`}>
        <div className="site-nav__inner">
          <Link to="/" className="site-nav__brand">
            <img src={logo} alt="Residency Hotels" />
          </Link>

          <button
            className={`site-nav__toggler ${mobileOpen ? "is-open" : ""}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle navigation"
          >
            <span className="site-nav__burger" />
            <span className="site-nav__burger" />
            <span className="site-nav__burger" />
          </button>

          {mobileOpen && (
            <div
              className="site-nav__overlay"
              onClick={() => setMobileOpen(false)}
            />
          )}

          <div className={`site-nav__menu ${mobileOpen ? "is-open" : ""}`}>
            <div className="site-nav__links">
              <button
                className="site-nav__book"
                onClick={(e) => {
                  getHotels(e);
                  setMobileOpen(false);
                }}
              >
                Book Now
              </button>
              <div className="site-nav__dropdown" ref={dropdownRef}>
                <button
                  className="site-nav__link site-nav__link--dropdown"
                  onClick={() =>
                    setActiveDropdown(
                      activeDropdown === "hotels" ? null : "hotels",
                    )
                  }
                >
                  Our Hotels
                  <FaChevronDown
                    className={`site-nav__chevron ${activeDropdown === "hotels" ? "is-open" : ""}`}
                  />
                </button>
                <div
                  className={`site-nav__dropdown-menu ${activeDropdown === "hotels" ? "is-open" : ""}`}
                >
                  {hotelsDropdown.map((item) => (
                    <a
                      key={item.stateName}
                      className="site-nav__dropdown-item"
                      onClick={(e) => handleDropdownClick(e, item.stateName)}
                    >
                      {item.label}
                    </a>
                  ))}
                  <a
                    className="site-nav__dropdown-item site-nav__dropdown-item--all"
                    onClick={getHotels}
                  >
                    View All Hotels
                  </a>
                </div>
              </div>

              <Link
                to="/Special-Promo"
                className={`site-nav__link ${isActive("/Special-Promo") ? "is-active" : ""}`}
                onClick={() => setMobileOpen(false)}
              >
                Special Promo
              </Link>
              <Link
                to="/EventHall"
                className={`site-nav__link ${isActive("/EventHall") ? "is-active" : ""}`}
                onClick={() => setMobileOpen(false)}
              >
                Event Center
              </Link>

              <Link
                to="/About-Residency-Hotels"
                className={`site-nav__link ${isActive("/About-Residency-Hotels") ? "is-active" : ""}`}
                onClick={() => setMobileOpen(false)}
              >
                About
              </Link>
            </div>

            <div className="site-nav__right">
              {isLoggedIn ? (
                <div className="site-nav__auth">
                  <Link
                    to="/favourites"
                    className={`site-nav__link site-nav__link--fav ${isActive("/favourites") ? "is-active" : ""}`}
                    onClick={() => setMobileOpen(false)}
                  >
                    <FaHeart className="site-nav__login-icon" />
                    Favourites
                  </Link>
                  <span className="site-nav__user">
                    <FaUser className="site-nav__user-icon" />
                    {userName && (
                      <span className="site-nav__user-name">{userName}</span>
                    )}
                  </span>
                  <button
                    className="site-nav__logout"
                    onClick={() => setShowLogoutModal(true)}
                    aria-label="Logout"
                  >
                    <FaSignOutAlt />
                    <span>Logout</span>
                  </button>
                </div>
              ) : (
                <Link
                  to="/login"
                  state={{ from: pathname }}
                  className={`site-nav__link site-nav__link--login ${isActive("/login") ? "is-active" : ""}`}
                  onClick={() => setMobileOpen(false)}
                  aria-label="Login"
                >
                  <FaUser className="site-nav__login-icon" /> Login
                </Link>
              )}
            </div>
          </div>
        </div>
      </nav>

      {showLogoutModal && (
        <div className="logout-modal__overlay" onClick={() => setShowLogoutModal(false)}>
          <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
            <h3 className="logout-modal__title">Confirm Logout</h3>
            <p className="logout-modal__text">Are you sure you want to log out?</p>
            <div className="logout-modal__actions">
              <button
                className="logout-modal__btn logout-modal__btn--cancel"
                onClick={() => setShowLogoutModal(false)}
              >
                Cancel
              </button>
              <button
                className="logout-modal__btn logout-modal__btn--confirm"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
